import { hasCookie } from '@theme/client-storage';
import { ThemeEvents } from '@theme/events';
import { onDocumentLoaded } from '@theme/utilities';
import { shouldPromptForConsent } from '@theme/visitor-state';

const MARKET_COOKIE = 'selected_market';

const showDuePrompts = async () => {
  const container = document.querySelector('[data-visitor-prompts]');
  if (!(container instanceof HTMLElement)) return;

  const suppressed = container.dataset.suppressedPrompt;

  const choiceDue = suppressed !== 'choice' && (await isChoiceDue());
  const regionDue = suppressed !== 'region' && !hasCookie(MARKET_COOKIE);

  if (!choiceDue && !regionDue) return;

  const markup = await fetchPrompts(container.dataset.url);
  if (!markup) return;

  const choice = choiceDue ? markup.querySelector('visitor-choice') : null;
  const region = regionDue ? markup.querySelector('region-selection') : null;

  await Promise.all([
    choice && import('@theme/visitor-choice'),
    region && import('@theme/region-selection'),
  ]);

  if (choice) container.append(choice);

  if (!region) return;

  if (choice) {
    document.addEventListener(ThemeEvents.consentCollected, () => container.append(region), {
      once: true,
    });
  } else {
    container.append(region);
  }
};

/**
 * @returns {Promise<boolean>}
 */
const isChoiceDue = async () => {
  try {
    return await shouldPromptForConsent();
  } catch (error) {
    console.error('Customer Privacy API unavailable:', error);
    return false;
  }
};

/**
 * @param {string} [url]
 * @returns {Promise<Document | null>}
 */
const fetchPrompts = async (url) => {
  if (!url) return null;

  try {
    const response = await fetch(url);

    if (!response.ok) throw new Error(`${url} responded ${response.status}`);

    return new DOMParser().parseFromString(await response.text(), 'text/html');
  } catch (error) {
    console.error('Could not load the visitor prompts:', error);
    return null;
  }
};

onDocumentLoaded(showDuePrompts);
